/**
 * Consolidated API Endpoints
 * All API routes in one place for easier management
 */

// API Endpoints mapped to paths
export const ENDPOINTS = {
  // Authentication
  AUTH: {
    LOGIN: '/api/auth/login',
    SAML_INIT: '/saml',
    SAML_FINALIZE: '/saml/finalize',
  },

  // Systems Management
  SYSTEMS: {
    GET_ALL: '/api/systems',
    GET_BY_NAME: (name) => `/api/systems/${name}`,
    GET_INFO: (name) => `/api/systems/${name}/info`,
    CREATE: '/api/systems/add',
    UPDATE: '/api/systems/edit',
    DELETE: '/api/systems/delete',
    TOGGLE_STATUS: '/api/systems/toggle-enabled',
  },

  // Input Data
  INPUTS: {
    GET_DATA: '/api/inputs/data',
    GENERATE_GRAPH: '/graphic_generator',
    DASHBOARD: '/api/dashboard',
  },

  // Output/Simulation
  SIMULATION: {
    GENERATE_IMAGE: '/api/generate_image',
    EXPORT_PDF: '/api/exportPDF',
    GET_STATUS: (id) => `/api/simulation/status/${id}`,
  },

  // Admin Management
  ADMIN: {
    GET_LIST: '/api/admin/list',
    CREATE: '/api/admin/add',
    DELETE: '/api/admin/delete',
    CHECK: '/api/admin/check',
  },

  // Video Management
  VIDEOS: {
    UPLOAD: '/api/videos/upload',
    GET_LIST: '/api/videos/list',
    GET_STREAM: (name) => `/api/videos/${name}`,
    DELETE: '/api/videos/delete',
  },

  // Analytics
  ANALYTICS: {
    GET_DATA: '/api/analytics/data',
    EXPORT: '/api/analytics/export',
    GET_SUMMARY: '/api/analytics/summary',
  },
};

export default ENDPOINTS;
